import React, { useContext, useEffect, useState } from "react";
import Header from "./Comman/Header";
import { OnmaxContext } from "../OnmaxContext";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import Pagination from "./Comman/Pagination";

export default function Withdrawal() {
  const {
    settings,
    copyaddress,
    toastSuccess,
    toastError,
    formatDateTime,
    formatAddress,
    udata: contextUdata, // Ensure we have access if needed, but we fetch updated profile below
  } = useContext(OnmaxContext);

  const withdrawFee = 10; //%
  const username = localStorage.getItem("username");
  const [amt, setamt] = useState(0);
  const [add, setadd] = useState("");
  const [tokenRcv, settokenRcv] = useState(0);
  const [tokenFee, settokenFee] = useState(0);
  const [data, setdata] = useState([]);
  const [dataadd, setdataadd] = useState([]);
  const [isLoading, setisLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [pages, setPages] = useState(1);
  const [otp, setOtp] = useState("");
  const [otpadd, setotpadd] = useState("");
  const navigate = useNavigate();
  const [withdrawalStatus, setWithdrawalStatus] = useState(false);
  const [withdrawalReason, setWithdrawalReason] = useState("");

  // OTP
  const [showOtp, setShowOtp] = useState(false);
  const [otpVerified, setOtpVerified] = useState(false);
  const [loadingOtp, setLoadingOtp] = useState(false);
  const [pendingAddressOTP, setPendingAddressOTP] = useState(false);
  const [udata, setUdata] = useState(null);
  const [withdrawLoading, setWithdrawLoading] = useState(false);
  const [showUpdateAddressModal, setShowUpdateAddressModal] = useState(false);
  const [updateAddressFormData, setUpdateAddressFormData] = useState("");
  const [updateAddressOtp, setUpdateAddressOtp] = useState("");
  const [showUpdateAddressOtp, setShowUpdateAddressOtp] = useState(false);
  const [loadingUpdateAddress, setLoadingUpdateAddress] = useState(false);
  const [updateAddressModalMsg, setUpdateAddressModalMsg] = useState({
    type: "",
    text: "",
  });
  const hasPendingWithdrawalRequest =
    udata?.alreadyRequestedWithdrawal === true;
  const hasPendingAddressRequest = udata?.alreadyRequestedAddress === true;

  const [checkingUser, setCheckingUser] = useState(true);

  /* ================= USER DATA ================= */
  const getUserData = async (silent = false) => {
    if (!username) {
      if (!silent) setCheckingUser(false);
      return;
    }

    try {
      const res = await axios.post(process.env.REACT_APP_BACKEND_LINK, {
        method: "user",
        submethod: "profile",
        username,
        key: process.env.REACT_APP_KEY,
      });

      if (!res.data?.error) {
        setUdata(res.data.data);
      }
    } catch (err) {
      console.error("getUserData error:", err);
    } finally {
      if (!silent) setCheckingUser(false);
    }
  };

  useEffect(() => {
    setCheckingUser(true);
    getUserData();
  }, [username]);

  // Reset OTP status if amount or address changes
  useEffect(() => {
    setOtpVerified(false);
    setShowOtp(false);
    setOtp("");
  }, [amt, add]);

  const isValidBSCAddress = (address) => {
    return /^0x[a-fA-F0-9]{40}$/.test(address);
  };

  const needsAddressVerification = udata?.verifyAddress === false;

  const submitAddressEmail = async () => {
    if (!add) {
      toastError("Enter Wallet Address");
      return;
    }

    if (!isValidBSCAddress(add)) {
      toastError("Invalid Address");
      return;
    }

    if (!udata?.email) {
      toastError("Verify Your Email");
      navigate("/verifyEmail");
      return;
    }

    try {
      setLoadingOtp(true);
      const res = await axios.post(
        process.env.REACT_APP_BACKEND_LINK,
        {
          method: "user",
          submethod: "sendupdateadd",
          key: process.env.REACT_APP_KEY,
          // username,
          email: udata?.email,
          address: add,
        },
        { withCredentials: true },
      );

      if (res.data?.resCode === 200) {
        toastSuccess(res.data?.message || "OTP sent to your email");
        setOtp("");
        setShowOtp(true);
        setPendingAddressOTP(true);
      }
      if (res.data?.resCode === 401) {
        toastError("Login Expired!");
        setShowOtp(false);
        setPendingAddressOTP(false);
        setOtp("");
        setLoadingOtp(false);

        // Call logout immediately
        try {
          const logout = await axios.post(
            process.env.REACT_APP_BACKEND_LINK,
            {
              method: "user",
              submethod: "logoutu",
              username: username,
              key: process.env.REACT_APP_KEY,
            },
            { withCredentials: true },
          );
          localStorage.clear();
          window.location.replace("/");
        } catch (error) {
          console.error("Logout failed:", error);
        }
        return;
      }

      if (res.data?.resCode === 400) {
        toastError(res.data?.error || res.data?.message || "Failed to send OTP");
        setShowOtp(false);
        setPendingAddressOTP(false);
        setOtp("");
        return;
      }
    } catch (err) {
      console.error(err);
      toastError("Failed to submit address");
      setShowOtp(false);
      setPendingAddressOTP(false);
      setOtp("");
    } finally {
      setLoadingOtp(false);
    }
  };

  const submitAddress = async (type) => {
    try {
      setWithdrawLoading(true);
      if (otp.length !== 6) {
        toastError("Enter valid 6-digit OTP");
        setWithdrawLoading(false);
        return;
      }
      const res = await axios.post(
        process.env.REACT_APP_BACKEND_LINK,
        {
          method: "user",
          submethod: "insertaddress",
          key: process.env.REACT_APP_KEY,
          // username: username,
          otp: otp,
          // amount: amt,
          address: add,
        },
        {
          withCredentials: true,
        },
      );

      if (res.data?.resCode === 200) {
        toastSuccess(res.data.msg || "Withdrawal Address Update");
        setamt(0);
        setadd("");
        setOtpVerified(false);
        setShowOtp(false);
        setOtp("");
        getDataPendingAddress();
        getUserData(true);
        setWithdrawLoading(false);
      }

      if (res.data?.resCode === 401) {
        toastError("Login Expired!");
        setShowOtp(false);
        setOtp("");
        setWithdrawLoading(false);

        // Call logout immediately
        try {
          const logout = await axios.post(
            process.env.REACT_APP_BACKEND_LINK,
            {
              method: "user",
              submethod: "logoutu",
              username: username,
              key: process.env.REACT_APP_KEY,
            },
            { withCredentials: true },
          );
          localStorage.clear();
          window.location.replace("/");
        } catch (error) {
          console.error("Logout failed:", error);
        }
        return;
      }

      if (res.data?.resCode === 400) {
        toastError(res.data?.message || res.data?.error || "Failed to update address");
        setWithdrawLoading(false);
        return;
      }
    } catch (err) {
      console.error("Address update error:", err);
      toastError("Something went wrong. Please try again.");
      setWithdrawLoading(false);
    } finally {
      setWithdrawLoading(false);
    }
  };

  /* ================= UPDATE ADDRESS MODAL FUNCTIONS ================= */
  const showUpdateAddressModalMsg = (type, text) => {
    setUpdateAddressModalMsg({ type, text });
  };

  const clearUpdateAddressModalMsg = () => {
    setUpdateAddressModalMsg({ type: "", text: "" });
  };

  const resetUpdateAddressModalState = () => {
    setUpdateAddressFormData("");
    setUpdateAddressOtp("");
    setShowUpdateAddressOtp(false);
    clearUpdateAddressModalMsg();
    setLoadingUpdateAddress(false);
  };

  const closeUpdateAddressModal = () => {
    setShowUpdateAddressModal(false);
    resetUpdateAddressModalState();
  };

  const sendUpdateAddressOtp = async () => {
    clearUpdateAddressModalMsg();

    if (!updateAddressFormData) {
      showUpdateAddressModalMsg("error", "Enter Wallet Address");
      return;
    }

    if (!isValidBSCAddress(updateAddressFormData)) {
      showUpdateAddressModalMsg("error", "Invalid Address");
      return;
    }

    if (!udata?.email) {
      showUpdateAddressModalMsg("error", "Verify Your Email first");
      return;
    }

    try {
      setLoadingUpdateAddress(true);
      const res = await axios.post(
        process.env.REACT_APP_BACKEND_LINK,
        {
          method: "user",
          submethod: "sendupdateadd",
          key: process.env.REACT_APP_KEY,
          email: udata?.email,
          address: updateAddressFormData,
        },
        { withCredentials: true },
      );

      if (res.data?.resCode === 200) {
        showUpdateAddressModalMsg(
          "success",
          res.data?.message || "OTP sent to your email",
        );
        setUpdateAddressOtp("");
        setShowUpdateAddressOtp(true);
      } else if (res.data?.resCode === 401) {
        showUpdateAddressModalMsg("error", "Login Expired!");
        setShowUpdateAddressOtp(false);
        setUpdateAddressOtp("");
        setLoadingUpdateAddress(false);
        localStorage.clear();
        window.location.replace("/");
      } else {
        showUpdateAddressModalMsg(
          "error",
          res.data?.error || res.data?.message || "Failed to send OTP",
        );
      }
    } catch (err) {
      console.error(err);
      showUpdateAddressModalMsg("error", "Failed to send OTP");
    } finally {
      setLoadingUpdateAddress(false);
    }
  };

  const submitUpdateAddress = async () => {
    clearUpdateAddressModalMsg();

    try {
      setLoadingUpdateAddress(true);
      if (updateAddressOtp.length !== 6) {
        showUpdateAddressModalMsg("error", "Enter valid 6-digit OTP");
        setLoadingUpdateAddress(false);
        return;
      }
      const res = await axios.post(
        process.env.REACT_APP_BACKEND_LINK,
        {
          method: "user",
          submethod: "insertaddress",
          key: process.env.REACT_APP_KEY,
          email: udata?.email,
          address: updateAddressFormData,
          otp: updateAddressOtp,
        },
        { withCredentials: true },
      );

      if (res.data?.resCode === 200) {
        showUpdateAddressModalMsg(
          "success",
          res.data?.message || "Address updated successfully",
        );
        getUserData(true);
        getDataPendingAddress();
        setTimeout(() => {
          closeUpdateAddressModal();
          toastSuccess(res.data?.message || "Address updated successfully");
        }, 1500);
      } else if (res.data?.resCode === 401) {
        showUpdateAddressModalMsg("error", "Login Expired!");
        setLoadingUpdateAddress(false);
        localStorage.clear();
        window.location.replace("/");
      } else {
        showUpdateAddressModalMsg(
          "error",
          res.data?.error || res.data?.message || "Failed to update address",
        );
        setLoadingUpdateAddress(false);
      }
    } catch (err) {
      console.error("Error updating address:", err);
      showUpdateAddressModalMsg("error", "Failed to update address");
      setLoadingUpdateAddress(false);
    } finally {
      setLoadingUpdateAddress(false);
    }
  };

  /* ================= SEND OTP ================= */
  const sendOtp = async () => {
    if (!udata?.withdrwalAddress) {
      toastError("Please set a withdrawal address first");
      return;
    }

    if (udata?.withdrawal_status === false) {
      toastError(
        "Your account is not eligible for withdrawal. Please contact support.",
      );
      return;
    }

    if (amt < settings[0].withdrawal_min) {
      toastError("Minimum withdrwal Amount is $10");
      return;
    }

    if (udata?.isGreater === false && Number(amt) !== 10) {
      toastError("Withdrawal amount must be $10");
      return;
    }

    if (udata?.balance < amt) {
      toastError("Insufficient balance for this withdrawal.");
      return;
    }

    if (udata?.restake === true) {
      toastError("Your account is restake mode!!");
      return;
    }

    if (udata?.status === false) {
      toastError("Your account is currently disabled. Please contact support.");
      return;
    }

    if (!amt || amt <= 0) {
      toastError("Enter Valid Amount");
      return;
    }

    // if (!udata?.contactno) {
    //   toastError("Verify Your Contact Number");
    //   navigate("/dashboard")
    //   return;
    // }
    if (!udata?.email) {
      toastError("Verify Your Email");
      navigate("/verifyEmail");
      return;
    }

    try {
      setLoadingOtp(true);

      const res = await axios.post(process.env.REACT_APP_BACKEND_LINK, {
        method: "user",
        submethod: "sendadd",
        key: process.env.REACT_APP_KEY,
        email: udata?.email,
        username,
        // password: udata?.password,
        address: udata?.withdrwalAddress,
        amount: amt,
      });
      if (res.data?.resCode === 200) {
        toastSuccess("OTP sent to your email");
        setOtp("");
        setShowOtp(true);
        setPendingAddressOTP(false);
      } else {
        toastError(res.data.error || res.data?.message || "Failed to send OTP");
        setShowOtp(false);
        setOtp("");
        setOtpVerified(false);
        return;
      }
    } catch (err) {
      console.error(err);
      toastError("Failed to send OTP");
      setShowOtp(false);
      setOtp("");
      setOtpVerified(false);
    } finally {
      setLoadingOtp(false);
    }
  };

  /* ================= VERIFY OTP ================= */
  const verifyOTP = async () => {
    if (otp.length !== 6) {
      toastError("Enter valid 6-digit OTP");
      return;
    }

    try {
      setLoadingOtp(true);
      const res = await axios.post(process.env.REACT_APP_BACKEND_LINK, {
        method: "user",
        submethod: "verifyemail",
        key: process.env.REACT_APP_KEY,
        email: udata.email,
        otp: otp,
      });

      if (res.data?.resCode === 200) {
        if (pendingAddressOTP) {
          const submitRes = await axios.post(
            process.env.REACT_APP_BACKEND_LINK,
            {
              method: "user",
              submethod: "submitaddress",
              key: process.env.REACT_APP_KEY,
              username,
              email: udata.email,
              address: add,
              otp: otp,
            },
            { withCredentials: true },
          );

          if (submitRes.data?.resCode === 200) {
            toastSuccess(
              submitRes.data?.message || "Address updated successfully",
            );
            setShowOtp(false);
            setPendingAddressOTP(false);
            setOtp("");
            setadd("");
            setLoadingOtp(false);
            getUserData(true);
            getDataPendingAddress();
          } else if (submitRes.data?.resCode === 401) {
            toastError("Login Expired!");
            setShowOtp(false);
            setPendingAddressOTP(false);
            setOtp("");
            setadd("");
            setLoadingOtp(false);
            localStorage.clear();
            window.location.replace("/");
          } else {
            toastError(
              submitRes.data?.error ||
              submitRes.data?.message ||
              "Failed to update address",
            );
            setOtp("");
            setLoadingOtp(false);
          }
        } else {
          toastSuccess(res.data?.message || "OTP verified");
          setOtpVerified(true);
          setShowOtp(false);
          setOtp("");
          setLoadingOtp(false);
        }
      } else if (res.data?.resCode === 401) {
        toastError("Login Expired!");
        setShowOtp(false);
        setOtp("");
        setLoadingOtp(false);
        localStorage.clear();
        window.location.replace("/");
      } else {
        toastError(res.data?.message || "Invalid OTP");
        setOtp("");
        setLoadingOtp(false);
      }
    } catch (err) {
      console.error(err);
      toastError("OTP verification failed");
      setOtp("");
      setLoadingOtp(false);
    } finally {
      setLoadingOtp(false);
    }
  };

  const withdraw = async (type) => {
    try {
      if (hasPendingWithdrawalRequest) {
        toastError("You already have a pending withdrawal request.");
        return;
      }

      if (udata?.isGreater === false && Number(amt) !== 10) {
        toastError("Withdrawal amount must be $10");
        return;
      }

      setWithdrawLoading(true);
      if (otp.length !== 6) {
        toastError("Enter valid 6-digit OTP");
        setWithdrawLoading(false);
        return;
      }
      const res = await axios.post(
        process.env.REACT_APP_BACKEND_LINK,
        {
          method: "withdrawal",
          submethod: "insert",
          key: process.env.REACT_APP_KEY,
          // username: username,
          otp: otp,
          amount: amt,
          address: udata?.withdrwalAddress,
        },
        {
          withCredentials: true,
        },
      );

      // console.log('res.data', res.data);
      getDataPending();

      if (res.data?.resCode === 200) {
        toastSuccess(res.data.msg || "Withdrawal successful");
        setamt(0);
        setOtpVerified(false);
        setShowOtp(false);
        setOtp("");
        setWithdrawLoading(false);
      }

      if (res.data?.resCode === 401) {
        toastError("Login Expired!");
        setWithdrawLoading(false);
        setShowOtp(false);
        setOtp("");

        // Call logout immediately
        try {
          const logout = await axios.post(
            process.env.REACT_APP_BACKEND_LINK,
            {
              method: "user",
              submethod: "logoutu",
              username: username,
              key: process.env.REACT_APP_KEY,
            },
            { withCredentials: true },
          );
          localStorage.clear();
          window.location.replace("/");
        } catch (error) {
          console.error("Logout failed:", error);
        }
      }

      if (res.data?.resCode === 400) {
        toastError(res.data.error || res.data?.message || "Withdrawal failed");
        setWithdrawLoading(false);
        return;
      }
    } catch (err) {
      console.error("Withdrawal error:", err);
      toastError("Something went wrong. Please try again.");
      setWithdrawLoading(false);
    } finally {
      setWithdrawLoading(false);
    }
  };

  const getDataPendingAddress = async () => {
    if (!username) return;

    try {
      setisLoading(true); // ✅ start loader

      const res = await axios.post(process.env.REACT_APP_BACKEND_LINK, {
        method: "user",
        submethod: "getlastadd",
        username: username,
        key: process.env.REACT_APP_KEY,
        page: currentPage,
        pageSize: pageSize,
      });

      if (res.data?.resCode !== 200) {
        // toastError(res.data?.error || "Failed to fetch data");
        return;
      }
      console.log("YES", res.data.data);

      setdataadd(res.data.data);
      setPages(Math.ceil(res.data.dataLength / pageSize));
    } catch (err) {
      console.error(err);
      // toastError("Server error");
    } finally {
      setisLoading(false); // ✅ stops ONLY after success/error
    }
  };

  useEffect(() => {
    getDataPendingAddress();
  }, [username, currentPage, pageSize]);

  const getDataPending = async () => {
    if (!username) return;

    try {
      setisLoading(true); // ✅ start loader

      const res = await axios.post(process.env.REACT_APP_BACKEND_LINK, {
        method: "withdrawal",
        submethod: "getpbyid",
        username: username,
        key: process.env.REACT_APP_KEY,
        page: currentPage,
        pageSize: pageSize,
      });

      if (res.data?.resCode !== 200) {
        // toastError(res.data?.error || "Failed to fetch data");
        return;
      }

      setdata(res.data.data);
      setPages(Math.ceil(res.data.dataLength / pageSize));
    } catch (err) {
      console.error(err);
      // toastError("Server error");
    } finally {
      setisLoading(false); // ✅ stops ONLY after success/error
    }
  };

  useEffect(() => {
    getDataPending();
  }, [username, currentPage, pageSize]);

  useEffect(() => {
    var tmtfee = (amt * 10) / 100;
    settokenFee(tmtfee);
    settokenRcv(amt - tmtfee);
  }, [amt]);

  useEffect(() => {
    if (Array.isArray(settings) && settings.length > 0) {
      const withdrwStatus = settings[0].all_withdrawal_status;
      const reason = settings[0].all_withdrawal_msg;
      setWithdrawalStatus(withdrwStatus === true);
      setWithdrawalReason(reason || "");
    }
  }, [settings]);

  const customStyles = `
    .bg-soft-warning { background-color: rgba(255, 193, 7, 0.1) !important; color: #ffc107 !important; }

    /* INPUTS */
    .db-input-group { margin-bottom: 24px; position: relative; }
    .db-input-label { font-size: 11px; text-transform: uppercase; letter-spacing: 1.5px; color: #64748b; font-weight: 800; margin-bottom: 8px; display: block; }
    .db-input-box { 
      background: rgba(238, 242, 246, 0.5); 
      border-radius: 16px; 
      padding: 12px 20px; 
      border: 1px solid rgba(255, 255, 255, 0.8);
      box-shadow: 1px 20px 20px 0px #bfc9d8, 0 10px 20px rgba(0, 0, 0, 0.05), inset 0 1px 0 #ffffff;
      display: flex; align-items: center; gap: 12px;
      position: relative;
      transition: all 0.3s;
    }
    .db-input-box:focus-within {
       border-color: #006fe3;
    }
    .db-input-field { background: transparent; border: none; outline: none; width: 100%; font-weight: 700; color: #1e293b; font-size: 16px; }
    .db-input-field::placeholder { color: #94a3b8; font-weight: 500; }
    .db-input-icon { color: #006fe3; font-size: 18px; }

    /* AMOUNT & FEES */
    .ai-summary-row {
      display: flex; justify-content: space-between;
      border-bottom: 1px solid rgba(0,0,0,0.05);
      padding: 12px 0;
      color: #64748b;
      font-size: 14px;
      font-weight: 600;
    }
    .ai-summary-row:last-child { border-bottom: none; }
    .ai-summary-val { color: #1e293b; font-weight: 700; font-family: monospace; font-size: 15px; }

    /* RESPONSIVE */
    @media (max-width: 768px) {
      .db-input-group { margin-bottom: 18px; }
      .db-input-label { font-size: 10px; }
      .db-input-box { padding: 10px 16px; border-radius: 12px; }
      .db-input-field { font-size: 14px; }
      .db-input-icon { font-size: 16px; }
      .ai-summary-row { font-size: 13px; padding: 10px 0; }
      .ai-summary-val { font-size: 14px; }
    }

    @media (max-width: 480px) {
      .db-input-group { margin-bottom: 16px; }
      .db-input-label { font-size: 9px; letter-spacing: 1px; }
      .db-input-box { padding: 8px 12px; gap: 8px; border-radius: 10px; }
      .db-input-field { font-size: 13px; }
      .db-input-icon { font-size: 14px; }
      .ai-summary-row { font-size: 12px; padding: 8px 0; }
      .ai-summary-val { font-size: 12px; }
    }

    .withdrawal-page-loader {
      min-height: 320px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 48px 24px;
    }
    .withdrawal-page-loader-text {
      margin-top: 16px;
      color: #64748b;
      font-size: 14px;
      font-weight: 700;
      letter-spacing: 0.5px;
    }

  `;

  return (
    <>
      <style>{customStyles}</style>
      <div className="body-bg">
        <Header />
        <section className="nftmax-adashboard nftmax-show mt-4 setting-section">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-6 col-md-8 col-12">
                {checkingUser ? (
                  <div className="db-profile-card mb-5 withdrawal-page-loader">
                    <div
                      className="spinner-border text-primary"
                      style={{ width: "3rem", height: "3rem" }}
                      role="status"
                    >
                      <span className="visually-hidden">Loading...</span>
                    </div>
                    <p className="withdrawal-page-loader-text mb-0">
                      Loading withdrawal data...
                    </p>
                  </div>
                ) : withdrawalStatus === false ? (
                  <div
                    className="db-profile-card mb-4 text-center"
                    style={{ border: "2px solid #ef4444" }}
                  >
                    <div className="text-danger fw-bold">
                      <i className="fa fa-ban me-2"></i>{" "}
                      {withdrawalReason || "Withdrawals Disabled"}
                    </div>
                  </div>
                ) : (
                  <div
                    className="db-profile-card mb-5"
                    style={{ position: "relative" }}
                  >
                    {/* Loading Overlay */}
                    {withdrawLoading && (
                      <div
                        style={{
                          position: "absolute",
                          top: 0,
                          left: 0,
                          right: 0,
                          bottom: 0,
                          background: "rgba(255, 255, 255, 0.9)",
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "center",
                          borderRadius: "16px",
                          zIndex: 10,
                        }}
                      >
                        <div
                          className="spinner-border text-primary mb-3"
                          style={{ width: "3rem", height: "3rem" }}
                        ></div>
                        <div className="text-center">
                          <div className="fw-bold text-dark">
                            Processing Withdrawal
                          </div>
                          <div className="small text-muted">
                            Please wait while we confirm your transaction...
                          </div>
                        </div>
                      </div>
                    )}

                    <div className="db-sec-hdr">
                      <div className="db-sec-dot"></div>
                      <div className="db-sec-title">Withdraw Funds</div>
                    </div>

                    <div className="p-0">
                      {/* Balance Pill */}
                      {!needsAddressVerification && (
                        <div className="text-center mb-4 mt-3">
                          <span
                            style={{
                              background: "rgba(16, 185, 129, 0.1)",
                              color: "#059669",
                              padding: "8px 20px",
                              borderRadius: "100px",
                              fontSize: "14px",
                              border: "1px solid rgba(16, 185, 129, 0.2)",
                              fontWeight: "800",
                              boxShadow: "0 4px 10px rgba(0,0,0,0.05)",
                            }}
                          >
                            Wallet Balance: $
                            {udata?.balance?.toFixed(2) || "0.00"}
                          </span>
                        </div>
                      )}

                      {/* Current Withdrawal Address Section */}
                      {!needsAddressVerification && (
                        <div
                          className="p-4 mb-4 rounded-4"
                          style={{
                            background: "#f8fafc",
                            border: "2px solid #e2e8f0",
                          }}
                        >
                          <div
                            className="mb-3 text-slate-500 font-weight-bold"
                            style={{
                              fontSize: "11px",
                              letterSpacing: "1.5px",
                              textTransform: "uppercase",
                              color: "#64748b",
                            }}
                          >
                            Current Withdrawal Address
                          </div>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                              gap: "12px",
                            }}
                          >
                            <div style={{ flex: 1, minWidth: 0 }}>
                              <p
                                style={{
                                  margin: 0,
                                  color: udata?.withdrwalAddress
                                    ? "#1e293b"
                                    : "#94a3b8",
                                  fontSize: "20px",
                                  fontWeight: "600",
                                  wordBreak: "break-all",
                                  fontFamily: "monospace",
                                }}
                              >
                                {udata?.withdrwalAddress
                                  ? (udata.withdrwalAddress)
                                  : "No address"}
                              </p>
                            </div>
                            {udata?.withdrwalAddress && (
                              <button
                                onClick={() => copyaddress(udata.withdrwalAddress)}
                                style={{
                                  background: "transparent",
                                  border: "none",
                                  color: "#0d6efd",
                                  cursor: "pointer",
                                  fontSize: "16px",
                                  padding: "4px 8px",
                                }}
                                title="Copy address"
                              >
                                <i className="fa fa-copy"></i>
                              </button>
                            )}
                          </div>
                          {/* <button
                            onClick={() => {
                              setShowUpdateAddressModal(true);
                              setUpdateAddressFormData("");
                              setUpdateAddressOtp("");
                              setShowUpdateAddressOtp(false);
                              clearUpdateAddressModalMsg();
                            }}
                            className="db-btn mt-3 w-100 py-2"
                            disabled={loadingUpdateAddress}
                            style={{
                              background: loadingUpdateAddress
                                ? "linear-gradient(135deg, #9ca3af, #6b7280)"
                                : "linear-gradient(135deg, #0d6efd, #0b5ed7)",
                              color: "white",
                              border: "none",
                              borderRadius: "8px",
                              fontWeight: "600",
                              fontSize: "13px",
                            }}
                          >
                            <i className="fa fa-edit me-2"></i>
                            {loadingUpdateAddress ? "Updating..." : "Update Address"}
                          </button> */}
                          <Link
                            to="/withdrwalAdress"
                            className="d-block text-center mt-3 small fw-bold text-primary text-decoration-none"
                          >
                            <i className="fa fa-history me-1"></i>
                            View Address History
                          </Link>
                        </div>
                      )}

                      {needsAddressVerification ? (
                        <>
                          <div className="db-input-group">
                            <label className="db-input-label">
                              Withdrawal Address (BEP20)
                            </label>
                            <div className="db-input-box">
                              <div className="db-input-icon-box icon-cyan">
                                <i className="fa fa-wallet db-input-icon"></i>
                              </div>
                              <input
                                className="db-input-field"
                                placeholder="Enter 0x..."
                                value={add}
                                disabled={loadingOtp || showOtp}
                                onChange={(e) => setadd(e.target.value)}
                              />
                            </div>
                          </div>

                          {showOtp && pendingAddressOTP ? (
                            <div
                              className="p-4 mb-4 rounded-4 text-center"
                              style={{
                                background: "#f8fafc",
                                border: "1px dashed #cbd5e1",
                              }}
                            >
                              <div
                                className="mb-3 text-slate-500 font-weight-bold"
                                style={{
                                  fontSize: "12px",
                                  letterSpacing: "1px",
                                  textTransform: "uppercase",
                                }}
                              >
                                ENTER OTP CODE
                              </div>
                              <div
                                className="db-input-box mx-auto"
                                style={{ maxWidth: "200px" }}
                              >
                                <input
                                  className="db-input-field text-center fs-4 p-0"
                                  placeholder="• • • • • •"
                                  maxLength={6}
                                  value={otp}
                                  onChange={(e) => {
                                    if (/^[0-9]*$/.test(e.target.value))
                                      setOtp(e.target.value);
                                  }}
                                  style={{ letterSpacing: "4px" }}
                                />
                              </div>
                              <button
                                className="db-btn mt-4 py-2 w-100"
                                onClick={submitAddress}
                                // disabled={
                                //   loadingOtp || hasPendingAddressRequest
                                // }
                                disabled={true}
                                style={{
                                  background: loadingOtp
                                    ? "linear-gradient(135deg, #9ca3af, #6b7280)"
                                    : hasPendingAddressRequest
                                      ? "linear-gradient(135deg, #9ca3af, #6b7280)"
                                      : "linear-gradient(135deg, #10b981, #059669)",
                                  color: "white",
                                  border: "none",
                                  borderRadius: "12px",
                                  fontWeight: "700",
                                }}
                              >
                                {loadingOtp
                                  ? "Updating..."
                                  : hasPendingAddressRequest
                                    ? "Pending Approval"
                                    : "Update Address"}
                              </button>
                            </div>
                          ) : (
                            <div className="mt-2">
                              <button
                                className="db-btn w-100 py-3 mt-2"
                                onClick={submitAddressEmail}
                                // disabled={
                                //   loadingOtp || hasPendingAddressRequest
                                // }
                                disabled={true}
                                style={{
                                  background: loadingOtp
                                    ? "linear-gradient(135deg, #9ca3af, #6b7280)"
                                    : hasPendingAddressRequest
                                      ? "linear-gradient(135deg, #9ca3af, #6b7280)"
                                      : "linear-gradient(135deg, #10b981, #059669)",
                                  color: "white",
                                  border: "none",
                                  borderRadius: "16px",
                                  fontWeight: "800",
                                }}
                              >
                                {loadingOtp
                                  ? "Submitting..."
                                  : hasPendingAddressRequest
                                    ? "Pending Approval"
                                    : "Submit Address"}
                              </button>
                              {hasPendingAddressRequest && (
                                <div className="text-warning text-center mt-3 fw-bold">
                                  You already have a pending withdrawal address
                                  request awaiting admin approval.
                                </div>
                              )}
                              <Link
                                to="/withdrwalAdress"
                                className="d-block text-center mt-3 small fw-bold text-primary text-decoration-none"
                              >
                                <i className="fa fa-history me-1"></i>
                                View Address History
                              </Link>
                            </div>
                          )}
                        </>
                      ) : (
                        <>
                          {/* Amount Input */}
                          <div className="db-input-group">
                            <label className="db-input-label">
                              Withdrawal Amount
                            </label>
                            <div className="db-input-box">
                              <div className="db-input-icon-box icon-cyan">
                                <i className="fas fa-dollar-sign db-input-icon"></i>
                              </div>
                              <input
                                type="number"
                                className="db-input-field"
                                placeholder="0.00"
                                disabled={showOtp}
                                value={amt}
                                style={{
                                  border: "none",
                                  outline: "none",
                                  boxShadow: "none",
                                  color: "#000",
                                }}
                                onChange={(e) => setamt(e.target.value)}
                              />
                            </div>
                          </div>

                          {/* Calculations */}
                          <div
                            className="p-3 rounded-4 mb-4"
                            style={{
                              background: "#f8fafc",
                              border: "1px solid #e2e8f0",
                            }}
                          >
                            <div className="ai-summary-row">
                              <span>Withdrawal Amount:</span>
                              <span className="ai-summary-val">
                                ${amt || 0}
                              </span>
                            </div>
                            <div className="ai-summary-row">
                              <span>Service Fee ({withdrawFee}%):</span>
                              <span className="ai-summary-val text-danger">
                                -${tokenFee || 0}
                              </span>
                            </div>
                            <div className="ai-summary-row border-0">
                              <span>You Receive:</span>
                              <span className="ai-summary-val text-success fs-5">
                                ${tokenRcv > 0 ? tokenRcv : 0}
                              </span>
                            </div>
                          </div>

                          {/* OTP Section */}
                          {showOtp && (
                            <div
                              className="p-4 mb-4 rounded-4 text-center"
                              style={{
                                background: "#f8fafc",
                                border: "1px dashed #cbd5e1",
                              }}
                            >
                              <div
                                className="mb-3 text-slate-500 font-weight-bold"
                                style={{
                                  fontSize: "12px",
                                  letterSpacing: "1px",
                                  textTransform: "uppercase",
                                }}
                              >
                                ENTER OTP CODE
                              </div>
                              <div
                                className="db-input-box mx-auto"
                                style={{ maxWidth: "200px" }}
                              >
                                <input
                                  className="db-input-field text-center fs-4 p-0"
                                  placeholder="• • • • • •"
                                  maxLength={6}
                                  value={otp}
                                  onChange={(e) => {
                                    if (/^[0-9]*$/.test(e.target.value))
                                      setOtp(e.target.value);
                                  }}
                                  style={{ letterSpacing: "4px" }}
                                />
                              </div>
                              <button
                                className="db-btn mt-4 py-2 w-100"
                                // onClick={() => withdraw(1)}
                                disabled={true}
                                style={{
                                  background:
                                    "linear-gradient(135deg, #3b82f6, #2563eb)",
                                  color: "white",
                                  border: "none",
                                  borderRadius: "12px",
                                  fontWeight: "700",
                                }}
                              >
                                Confirm Identity
                              </button>
                            </div>
                          )}

                          {/* Actions */}
                          <div className="mt-2">
                            {!loadingOtp && !showOtp && !otpVerified && (
                              <button
                                className="db-btn w-100 py-3 mt-2"
                                // onClick={sendOtp}
                                // disabled={hasPendingWithdrawalRequest}
                                disabled={true}
                                style={{
                                  background: hasPendingWithdrawalRequest
                                    ? "linear-gradient(135deg, #9ca3af, #6b7280)"
                                    : "linear-gradient(135deg, #10b981, #059669)",
                                  color: "white",
                                  border: "none",
                                  borderRadius: "16px",
                                  fontWeight: "800",
                                  boxShadow:
                                    "0 10px 20px rgba(16, 185, 129, 0.3)",
                                  cursor: hasPendingWithdrawalRequest
                                    ? "not-allowed"
                                    : "pointer",
                                  opacity: hasPendingWithdrawalRequest
                                    ? 0.7
                                    : 1,
                                }}
                              >
                                {hasPendingWithdrawalRequest
                                  ? "ALREADY HAVE REQUEST"
                                  : "PROCEED VERIFICATION"}
                              </button>
                            )}
                            {hasPendingWithdrawalRequest && (
                              <div className="text-warning text-center mt-3 fw-bold">
                                You already have a pending withdrawal request.
                              </div>
                            )}
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>

            {!checkingUser && needsAddressVerification && (
              <div className="row justify-content-center">
                <div className="col-lg-10 col-12">
                  <div className="db-profile-card mb-5">
                    <div className="db-sec-hdr">
                      <div className="db-sec-dot"></div>
                      <div className="db-sec-title">Pending Address</div>
                    </div>

                    <div className="card-body p-0 mt-3">
                      <div className="table-responsive">
                        <table
                          className="table table-dashboard-premium align-middle mb-0"
                          style={{ minWidth: "700px" }}
                        >
                          <thead className="text-uppercase small">
                            <tr>
                              {/* <th scope="col" className="ps-4 py-3">Amount</th> */}
                              <th scope="col" className="py-3">
                                Address
                              </th>
                              {/* <th scope="col" className="py-3">Fee</th> */}
                              {/* <th scope="col" className="py-3">Total Receive</th> */}
                              <th scope="col" className="py-3">
                                Status
                              </th>
                              <th scope="col" className="pe-4 py-3 text-end">
                                Date
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {isLoading && !dataadd.length ? (
                              <tr>
                                <td colSpan="6" className="text-center py-5">
                                  <div
                                    className="spinner-border text-primary"
                                    role="status"
                                  ></div>
                                </td>
                              </tr>
                            ) : !dataadd.length ? (
                              <tr>
                                <td
                                  colSpan="6"
                                  className="text-center py-5 text-slate-400"
                                >
                                  No records found
                                </td>
                              </tr>
                            ) : (
                              dataadd.map((e, i) => (
                                <tr key={i} className="table-tr-premium">
                                  {/* <td className="ps-4"><span className="fw-bold text-white-custom">${e.amount}</span></td> */}
                                  <td>
                                    <span
                                      className="text-primary cursor-pointer small"
                                      onClick={() => copyaddress(e.address)}
                                    >
                                      {e.address
                                        ? formatAddress(e.address)
                                        : "-"}{" "}
                                      <i className="fa fa-copy ms-1"></i>
                                    </span>
                                  </td>
                                  {/* <td><span className="text-danger small">${e.fee}</span></td> */}
                                  {/* <td><span className="fw-bold text-success">${e.totalrcv}</span></td> */}
                                  <td>
                                    {e.adminApprove === false ? (
                                      <span className="badge bg-soft-warning">
                                        Pending
                                      </span>
                                    ) : (
                                      <span className="badge bg-soft-success">
                                        Verified
                                      </span>
                                    )}
                                  </td>
                                  <td className="pe-4 text-end">
                                    {e.date ? (
                                      <span className="text-slate-400 small">
                                        {formatDateTime(e.date)}
                                      </span>
                                    ) : (
                                      "-"
                                    )}
                                  </td>
                                </tr>
                              ))
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <div className="card-footer bg-transparent border-top border-secondary border-opacity-10 p-4">
                      <Pagination
                        currentPage={currentPage}
                        setCurrentPage={setCurrentPage}
                        pageSize={pageSize}
                        setPageSize={setPageSize}
                        pages={pages}
                      />
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* Pending Withdrawal TABLE */}
            {!checkingUser && !needsAddressVerification && (
              <div className="row justify-content-center">
                <div className="col-lg-10 col-12">
                  <div className="db-profile-card mb-5">
                    <div className="db-sec-hdr">
                      <div className="db-sec-dot"></div>
                      <div className="db-sec-title">Pending Withdrawals</div>
                    </div>

                    <div className="card-body p-0 mt-3">
                      <div className="table-responsive">
                        <table
                          className="table table-dashboard-premium align-middle mb-0"
                          style={{ minWidth: "700px" }}
                        >
                          <thead className="text-uppercase small">
                            <tr>
                              <th scope="col" className="ps-4 py-3">
                                Amount
                              </th>
                              <th scope="col" className="py-3">
                                Address
                              </th>
                              <th scope="col" className="py-3">
                                Fee
                              </th>
                              <th scope="col" className="py-3">
                                Total Receive
                              </th>
                              <th scope="col" className="py-3">
                                Status
                              </th>
                              <th scope="col" className="pe-4 py-3 text-end">
                                Date
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {isLoading && !data.length ? (
                              <tr>
                                <td colSpan="6" className="text-center py-5">
                                  <div
                                    className="spinner-border text-primary"
                                    role="status"
                                  ></div>
                                </td>
                              </tr>
                            ) : !data.length ? (
                              <tr>
                                <td
                                  colSpan="6"
                                  className="text-center py-5 text-slate-400"
                                >
                                  No records found
                                </td>
                              </tr>
                            ) : (
                              data.map((e, i) => (
                                <tr key={i} className="table-tr-premium">
                                  <td className="ps-4">
                                    <span className="fw-bold text-white-custom">
                                      ${e.amount}
                                    </span>
                                  </td>
                                  <td>
                                    <span
                                      className="text-primary cursor-pointer small"
                                      onClick={() => copyaddress(e.address)}
                                    >
                                      {e.address
                                        ? formatAddress(e.address)
                                        : "-"}{" "}
                                      <i className="fa fa-copy ms-1"></i>
                                    </span>
                                  </td>
                                  <td>
                                    <span className="text-danger small">
                                      ${e.fee}
                                    </span>
                                  </td>
                                  <td>
                                    <span className="fw-bold text-success">
                                      ${e.totalrcv}
                                    </span>
                                  </td>
                                  <td>
                                    {e.status === false ? (
                                      <span className="badge bg-soft-warning">
                                        Pending
                                      </span>
                                    ) : (
                                      <span className="badge bg-soft-success">
                                        Complete
                                      </span>
                                    )}
                                  </td>
                                  <td className="pe-4 text-end">
                                    {e.date ? (
                                      <span className="text-slate-400 small">
                                        {formatDateTime(e.date)}
                                      </span>
                                    ) : (
                                      "-"
                                    )}
                                  </td>
                                </tr>
                              ))
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <div className="card-footer bg-transparent border-top border-secondary border-opacity-10 p-4">
                      <Pagination
                        currentPage={currentPage}
                        setCurrentPage={setCurrentPage}
                        pageSize={pageSize}
                        setPageSize={setPageSize}
                        pages={pages}
                      />
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </section>
      </div>

      {/* Update Address Modal */}
      {showUpdateAddressModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: "rgba(0, 0, 0, 0.6)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
            padding: "20px",
          }}
          onClick={() => {
            if (!loadingUpdateAddress) {
              closeUpdateAddressModal();
            }
          }}
        >
          <div
            style={{
              background: "white",
              borderRadius: "20px",
              padding: "30px 25px",
              maxWidth: "450px",
              width: "100%",
              boxShadow: "0 20px 60px rgba(0, 0, 0, 0.3)",
              maxHeight: "90vh",
              overflowY: "auto",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            {/* Close Button */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "20px",
              }}
            >
              <h3 style={{ margin: 0, color: "#1e293b", fontWeight: "800", fontSize: "18px" }}>
                Update Withdrawal Address
              </h3>
              <button
                onClick={() => {
                  if (!loadingUpdateAddress) {
                    closeUpdateAddressModal();
                  }
                }}
                // disabled={loadingUpdateAddress}
                disabled={true}
                style={{
                  background: "transparent",
                  border: "none",
                  fontSize: "24px",
                  color: "#64748b",
                  cursor: "pointer",
                  padding: 0,
                  opacity: loadingUpdateAddress ? 0.5 : 1,
                }}
              >
                ×
              </button>
            </div>

            {updateAddressModalMsg.text && (
              <div
                role="alert"
                style={{
                  padding: "12px 16px",
                  borderRadius: "10px",
                  marginBottom: "16px",
                  background:
                    updateAddressModalMsg.type === "error" ? "#fef2f2" : "#f0fdf4",
                  border: `1px solid ${updateAddressModalMsg.type === "error" ? "#fecaca" : "#bbf7d0"
                    }`,
                  color:
                    updateAddressModalMsg.type === "error" ? "#b91c1c" : "#15803d",
                  fontSize: "14px",
                  fontWeight: "600",
                  display: "flex",
                  alignItems: "flex-start",
                  gap: "8px",
                }}
              >
                <i
                  className={`fa ${updateAddressModalMsg.type === "error"
                    ? "fa-exclamation-circle"
                    : "fa-check-circle"
                    }`}
                  style={{ marginTop: "2px" }}
                />
                <span>{updateAddressModalMsg.text}</span>
              </div>
            )}

            {/* Form Content */}
            {!showUpdateAddressOtp ? (
              <>
                {/* Address Input */}
                <div className="db-input-group mb-4">
                  <label className="db-input-label">
                    New Wallet Address (BEP20)
                  </label>
                  <div className="db-input-box">
                    <div className="db-input-icon-box icon-cyan">
                      <i className="fa fa-wallet db-input-icon"></i>
                    </div>
                    <input
                      className="db-input-field"
                      placeholder="Enter 0x..."
                      value={updateAddressFormData}
                      disabled={loadingUpdateAddress}
                      onChange={(e) => {
                        setUpdateAddressFormData(e.target.value);
                        clearUpdateAddressModalMsg();
                      }}
                    />
                  </div>
                </div>

                {/* Send OTP Button */}
                <button
                  className="db-btn w-100 py-3"
                  // onClick={sendUpdateAddressOtp}
                  // disabled={loadingUpdateAddress || !updateAddressFormData}
                  disabled={true}
                  style={{
                    background: loadingUpdateAddress || !updateAddressFormData
                      ? "linear-gradient(135deg, #9ca3af, #6b7280)"
                      : "linear-gradient(135deg, #10b981, #059669)",
                    color: "white",
                    border: "none",
                    borderRadius: "12px",
                    fontWeight: "700",
                    cursor: loadingUpdateAddress || !updateAddressFormData ? "not-allowed" : "pointer",
                    opacity: loadingUpdateAddress || !updateAddressFormData ? 0.7 : 1,
                    fontSize: "14px",
                  }}
                >
                  {loadingUpdateAddress ? (
                    <>
                      <i className="fa fa-spinner fa-spin me-2"></i>Sending OTP...
                    </>
                  ) : (
                    <>
                      <i className="fa fa-envelope me-2"></i>Send OTP to Email
                    </>
                  )}
                </button>
              </>
            ) : (
              <>
                {/* OTP Verification Section */}
                <div
                  className="p-4 mb-4 rounded-4 text-center"
                  style={{
                    background: "#f8fafc",
                    border: "1px dashed #cbd5e1",
                  }}
                >
                  <p
                    style={{
                      color: "#64748b",
                      fontSize: "12px",
                      marginBottom: "16px",
                      margin: 0,
                    }}
                  >
                    OTP has been sent to your email. Enter it below:
                  </p>

                  <div
                    className="db-input-box mx-auto mb-3"
                    style={{ maxWidth: "200px" }}
                  >
                    <input
                      className="db-input-field text-center fs-4 p-0"
                      placeholder="• • • • • •"
                      maxLength={6}
                      value={updateAddressOtp}
                      disabled={loadingUpdateAddress}
                      onChange={(e) => {
                        if (/^[0-9]*$/.test(e.target.value)) {
                          setUpdateAddressOtp(e.target.value);
                          clearUpdateAddressModalMsg();
                        }
                      }}
                      style={{ letterSpacing: "4px", fontSize: "18px" }}
                    />
                  </div>

                  <button
                    className="db-btn mt-4 py-3 w-100"
                    onClick={submitUpdateAddress}
                    // disabled={loadingUpdateAddress || updateAddressOtp.length !== 6}
                    disabled={true}
                    style={{
                      background:
                        loadingUpdateAddress || updateAddressOtp.length !== 6
                          ? "linear-gradient(135deg, #9ca3af, #6b7280)"
                          : "linear-gradient(135deg, #3b82f6, #2563eb)",
                      color: "white",
                      border: "none",
                      borderRadius: "12px",
                      fontWeight: "700",
                      cursor:
                        loadingUpdateAddress || updateAddressOtp.length !== 6
                          ? "not-allowed"
                          : "pointer",
                      opacity:
                        loadingUpdateAddress || updateAddressOtp.length !== 6
                          ? 0.7
                          : 1,
                      fontSize: "14px",
                    }}
                  >
                    {loadingUpdateAddress ? (
                      <>
                        <i className="fa fa-spinner fa-spin me-2"></i>Updating...
                      </>
                    ) : (
                      <>
                        <i className="fa fa-check me-2"></i>Verify & Update
                      </>
                    )}
                  </button>

                  <button
                    type="button"
                    onClick={() => {
                      if (!loadingUpdateAddress) {
                        resetUpdateAddressModalState();
                      }
                    }}
                    // disabled={loadingUpdateAddress} 
                    disabled={true}
                    style={{
                      background: "transparent",
                      color: "#0d6efd",
                      border: "none",
                      marginTop: "12px",
                      cursor: "pointer",
                      fontSize: "13px",
                      textDecoration: "underline",
                      fontWeight: "600",
                      opacity: loadingUpdateAddress ? 0.5 : 1,
                    }}
                  >
                    Back
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      )}
    </>
  );
}
